import gql from 'graphql-tag';

const GET_ACTIVITY_TYPES = gql`
{
    getAllActivityTypes{
        name
    }
}
`;
export default GET_ACTIVITY_TYPES;